import moment from 'moment'

export const disabledBeforeCurrentDate = (current) => {
  const beForeCurrent = moment().subtract(1, 'day')
  return current && current < beForeCurrent.endOf('day')
}
